module.exports = __webpack_public_path__ + "static/img/Logo.18778c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/garden-help/Logo.png
// module id = nPCJ
// module chunks = 0